module.exports = __webpack_public_path__ + "img/people-3.9274f3a1.png";